export const AUTH_TOKEN = 'auth_token'
export const USER_EMAIL = 'user_email'
export const USER_NAME = 'user_name'
export const USER_AVATAR = 'user_avatar'
export const USER_TYPE = 'user_type'
export const USER_CONTACT = 'user_contact'
export const USER_ID = 'user_id'
export const COMPANY_IMG_REGULAR = 'company_img_regular'
export const COMPANY_IMG_REGULAR_SM = 'company_img_regular_sm'
export const COMPANY_IMG_WHITE = 'company_img_white'
export const COMPANY_IMG_WHITE_SM = 'company_img_white_sm'